import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=1cea4ec6&scoped=true"
import script from "./PermissionList.vue?vue&type=script&lang=js"
export * from "./PermissionList.vue?vue&type=script&lang=js"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=1cea4ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea4ec6",
  null
  
)

export default component.exports